import React from 'react';

/**
 * Gauge SVG semicircular minimalista para acompañar KPIs de "estado en vivo".
 *
 * Usa thresholds para colorear el arco activo:
 *   - value <= warning  → verde
 *   - value <= danger   → ámbar
 *   - value >  danger   → rojo
 *
 * El track de fondo respeta el tema (border-secondary). El indicador es un
 * arco proporcional a min(value/scaleMax, 1).
 *
 * size: ancho en px del SVG (alto = size/2 + padding por el "tick").
 */
const MiniGauge = ({
  value = 0,
  scaleMax = 200,
  warning = 50,
  danger = 200,
  size = 90,
  strokeWidth = 8,
  showLabel = true,
}) => {
  const v = Math.max(0, Number(value) || 0);
  const ratio = scaleMax > 0 ? Math.min(v / scaleMax, 1) : 0;

  const color = v <= warning ? '#10B981' : v <= danger ? '#F59E0B' : '#DC2626';

  const cx = size / 2;
  const cy = size / 2;
  const r = (size - strokeWidth) / 2;
  // Semicirculo de izquierda a derecha (de 180° a 360° / 0°).
  const startAngle = Math.PI; // 180°
  const endAngle = 2 * Math.PI; // 360°
  const arcLen = (endAngle - startAngle) * r;

  const polar = (angle) => [cx + r * Math.cos(angle), cy + r * Math.sin(angle)];
  const [x1, y1] = polar(startAngle);
  const [x2, y2] = polar(endAngle);
  const trackPath = `M ${x1} ${y1} A ${r} ${r} 0 0 1 ${x2} ${y2}`;

  return (
    <div className="ai-perf-gauge" style={{ display: 'inline-block', textAlign: 'center' }}>
      <svg width={size} height={size / 2 + strokeWidth} role="img" aria-label="gauge">
        <path
          d={trackPath}
          fill="none"
          stroke="var(--border-secondary, #E5E7EB)"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        <path
          d={trackPath}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={`${arcLen * ratio} ${arcLen}`}
          style={{ transition: 'stroke-dasharray 350ms ease, stroke 350ms ease' }}
        />
      </svg>
      {showLabel && (
        <div
          style={{
            fontSize: 11,
            color: 'var(--text-tertiary)',
            marginTop: -4,
          }}
        >
          0 — {scaleMax}
        </div>
      )}
    </div>
  );
};

export default MiniGauge;
